import {
  PaymentType,
  PaymentStatus,
  ShippingStatus,
  OrderPrivilegeStatus,
} from './order-privilege.types'

export const ORDER_STATUS_OPTIONS = [
  { label: 'ทั้งหมด', value: 'all' },
  { label: 'รอดำเนินการ', value: OrderPrivilegeStatus.PENDING },
  { label: 'รอชำระเงิน', value: OrderPrivilegeStatus.PAYMENT_PENDING },
  { label: 'ชำระแล้ว', value: OrderPrivilegeStatus.PAID },
  { label: 'กำลังจัดการ', value: OrderPrivilegeStatus.PROCESSING },
  { label: 'จัดส่งแล้ว', value: OrderPrivilegeStatus.SHIPPED },
  { label: 'ส่งถึงแล้ว', value: OrderPrivilegeStatus.DELIVERED },
  { label: 'ยกเลิก', value: OrderPrivilegeStatus.CANCELLED },
  { label: 'คืนเงิน', value: OrderPrivilegeStatus.REFUNDED },
  { label: 'หมดอายุ', value: OrderPrivilegeStatus.EXPIRED },
] as const

export const SHIPPING_STATUS_OPTIONS = [
  { label: 'ทั้งหมด', value: 'all' },
  { label: 'รับเอง', value: ShippingStatus.SELF_PICKUP },
  { label: 'รอจัดส่ง', value: ShippingStatus.PENDING },
  { label: 'กำลังจัดส่ง', value: ShippingStatus.PROCESSING },
  { label: 'จัดส่งแล้ว', value: ShippingStatus.SHIPPED },
  { label: 'ส่งถึงแล้ว', value: ShippingStatus.DELIVERED },
  { label: 'ส่งไม่สำเร็จ', value: ShippingStatus.FAILED },
  { label: 'ส่งคืน', value: ShippingStatus.RETURNED },
] as const

export const PAYMENT_STATUS_OPTIONS = [
  { label: 'ทั้งหมด', value: 'all' },
  { label: 'รอชำระ', value: PaymentStatus.PENDING },
  { label: 'กำลังยืนยัน', value: PaymentStatus.PROCESSING },
  { label: 'สำเร็จ', value: PaymentStatus.SUCCESS },
  { label: 'ล้มเหลว', value: PaymentStatus.FAILED },
  { label: 'ยกเลิก', value: PaymentStatus.CANCELLED },
  { label: 'คืนเงิน', value: PaymentStatus.REFUNDED },
] as const

export const PAYMENT_TYPE_OPTIONS = [
  { label: 'ทั้งหมด', value: 'all' },
  { label: 'เงินสด', value: PaymentType.CASH },
  { label: 'โทเคน', value: PaymentType.TOKEN },
  { label: 'ผสม', value: PaymentType.MIXED },
  { label: 'ฟรี', value: PaymentType.FREE },
] as const

export const getOrderStatusLabel = (value: OrderPrivilegeStatus): string => {
  const found = ORDER_STATUS_OPTIONS.find((o) => o.value === value)
  return found ? found.label : String(value)
}

export const getShippingStatusLabel = (value: ShippingStatus): string => {
  const found = SHIPPING_STATUS_OPTIONS.find((o) => o.value === value)
  return found ? found.label : String(value)
}

export const getPaymentStatusLabel = (value: PaymentStatus): string => {
  const found = PAYMENT_STATUS_OPTIONS.find((o) => o.value === value)
  return found ? found.label : String(value)
}

export const getPaymentTypeLabel = (value: PaymentType): string => {
  const found = PAYMENT_TYPE_OPTIONS.find((o) => o.value === value)
  return found ? found.label : String(value)
}

// ===== Badge color helpers =====
export const getOrderStatusBadgeClass = (
  status: OrderPrivilegeStatus,
): string => {
  switch (status) {
    case OrderPrivilegeStatus.PENDING:
      return 'bg-yellow-500 text-white'
    case OrderPrivilegeStatus.PAYMENT_PENDING:
      return 'bg-orange-500 text-white'
    case OrderPrivilegeStatus.PAID:
      return 'bg-blue-500 text-white'
    case OrderPrivilegeStatus.PROCESSING:
      return 'bg-purple-500 text-white'
    case OrderPrivilegeStatus.SHIPPED:
      return 'bg-indigo-500 text-white'
    case OrderPrivilegeStatus.DELIVERED:
      return 'bg-green-500 text-white'
    case OrderPrivilegeStatus.CANCELLED:
      return 'bg-red-500 text-white'
    case OrderPrivilegeStatus.REFUNDED:
      return 'bg-gray-500 text-white'
    case OrderPrivilegeStatus.EXPIRED:
      return 'bg-gray-600 text-white'
    default:
      return 'bg-gray-300 text-black'
  }
}

export const getShippingStatusBadgeClass = (status: ShippingStatus): string => {
  switch (status) {
    case ShippingStatus.PENDING:
      return 'bg-yellow-500 text-white'
    case ShippingStatus.PROCESSING:
      return 'bg-orange-500 text-white'
    case ShippingStatus.SHIPPED:
      return 'bg-purple-500 text-white'
    case ShippingStatus.DELIVERED:
      return 'bg-green-500 text-white'
    case ShippingStatus.FAILED:
      return 'bg-red-500 text-white'
    case ShippingStatus.RETURNED:
      return 'bg-gray-500 text-white'
    default:
      return 'bg-gray-300 text-black'
  }
}

export const getPaymentStatusBadgeClass = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentStatus.PENDING:
      return 'bg-yellow-500 text-white'
    case PaymentStatus.PROCESSING:
      return 'bg-orange-500 text-white'
    case PaymentStatus.SUCCESS:
      return 'bg-green-500 text-white'
    case PaymentStatus.FAILED:
      return 'bg-red-500 text-white'
    case PaymentStatus.CANCELLED:
      return 'bg-gray-500 text-white'
    case PaymentStatus.REFUNDED:
      return 'bg-blue-500 text-white'
    default:
      return 'bg-gray-300 text-black'
  }
}
